import(/* webpackMode: "eager" */ "/work/node_modules/next/dist/client/app-dir/link.js");
